function showKetchPreferences(event) {
  event.preventDefault();

  if (typeof ketch === 'function') {
    ketch('showPreferences');
    return;
  }

  const url = new URL(window.location.href);
  url.searchParams.set('ketch_show', 'preferences');
  window.location.assign(url);
}

function bindKetchFooterLink(link) {
  if (link.dataset.ketchBound === 'true') return;
  link.dataset.ketchBound = 'true';

  link.addEventListener('click', showKetchPreferences);

  link.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      link.click();
    }
  });
}

function initKetchFooterLinks() {
  document
    .querySelectorAll('[data-ketch-preferences], a[href*="ketch_show=preferences"], a[href="#ketch-preferences"]')
    .forEach(bindKetchFooterLink);

  document.querySelectorAll('.shopify-section--footer').forEach((footer) => {
    if (footer.dataset.ketchDelegation === 'true') return;
    footer.dataset.ketchDelegation = 'true';

    footer.addEventListener('click', (event) => {
      const link = event.target.closest(
        'a[data-ketch-preferences], a[href*="ketch_show=preferences"], a[href="#ketch-preferences"]'
      );

      if (!link || !footer.contains(link)) return;

      showKetchPreferences(event);
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initKetchFooterLinks);
} else {
  initKetchFooterLinks();
}

document.addEventListener('shopify:section:load', initKetchFooterLinks);
